export async function fetchChatHistory({ baseurl, uid, clientId, grantId }) {
  const response = await fetch(`${baseurl}/chat-history`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      user_id: uid || localStorage.getItem("user_id"),
      client_organization_id: clientId,
      grant_proposal_form_id: grantId,
    }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  return data;
}
